"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendingHashableFields = exports.SendingsFallbacksStates = exports.SendingStatus = exports.SendingTypes = void 0;
var SendingTypes;
(function (SendingTypes) {
    SendingTypes["sms"] = "sms";
    SendingTypes["push"] = "push";
    SendingTypes["viber"] = "viber";
    SendingTypes["voice"] = "voice";
    SendingTypes["whatsapp"] = "whatsapp";
    SendingTypes["vk"] = "vk";
    SendingTypes["flashcall"] = "flashcall";
    SendingTypes["telegramcode"] = "telegramcode";
    // Не используется:
    SendingTypes["ok"] = "ok";
    SendingTypes["whatsappchat"] = "whatsappchat";
    SendingTypes["viberchat"] = "viberchat";
    SendingTypes["vkchat"] = "vkchat";
    SendingTypes["telegramchat"] = "telegramchat";
    SendingTypes["facebookchat"] = "facebookchat";
})(SendingTypes || (exports.SendingTypes = SendingTypes = {}));
var SendingStatus;
(function (SendingStatus) {
    SendingStatus["pending"] = "pending";
    SendingStatus["paused"] = "paused";
    SendingStatus["processing"] = "processing";
    SendingStatus["sent"] = "sent";
    SendingStatus["delivered"] = "delivered";
    SendingStatus["seen"] = "seen";
    SendingStatus["failed"] = "failed";
})(SendingStatus || (exports.SendingStatus = SendingStatus = {}));
var SendingsFallbacksStates;
(function (SendingsFallbacksStates) {
    SendingsFallbacksStates["created"] = "created";
    SendingsFallbacksStates["ready"] = "ready";
    SendingsFallbacksStates["processing"] = "processing";
    SendingsFallbacksStates["done"] = "done";
    SendingsFallbacksStates["failed"] = "failed";
})(SendingsFallbacksStates || (exports.SendingsFallbacksStates = SendingsFallbacksStates = {}));
var SendingHashableFields;
(function (SendingHashableFields) {
    SendingHashableFields["payload"] = "payload";
    SendingHashableFields["type"] = "type";
})(SendingHashableFields || (exports.SendingHashableFields = SendingHashableFields = {}));
//# sourceMappingURL=sendings.enum.js.map